'use memo'

import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../config/queryKeys'
import { getMePlayers } from '../services/player/userPlayersServices'

const STALE_TIME = 5 * 60 * 1000

interface UseUserPlayersQueryResult {
  playerIds: string[]
  isPending: boolean
  isError: boolean
}

export const useUserPlayersQuery = (): UseUserPlayersQueryResult => {
  const { data, isPending, isError } = useQuery({
    queryKey: queryKeys.userPlayers.me(),
    queryFn: getMePlayers,
    staleTime: STALE_TIME,
  })

  const playerIds = data
    ? Array.from(new Set(data.map((player: { id: string }) => player.id)))
    : []

  return { playerIds, isPending, isError }
}
